export default __webpack_public_path__ + "static/media/shadow-clear-spring.911dfb70.png";